  
import React, { useEffect, useState } from "react";
import { Table, Spinner, Alert, Input, Button } from "reactstrap";
import axiosInstance from "../../Request";
import { URL } from "../../api";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

const CibilReportMIS = () => {
  const [data, setData] = useState([]);
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [customerId, setCustomerId] = useState("");
  const [loanId, setLoanId] = useState("");
  const [status, setStatus] = useState("");  
  const [filterType, setFilterType] = useState("");  
  const [loading, setLoading] = useState(true);
  const [filtering, setFiltering] = useState(false);
    const [filteredData, setFilteredData] = useState([]);

  const [error, setError] = useState("");

  useEffect(() => {
    fetchPanSummary();
  }, []);

 
const fetchPanSummary = () => {
  setLoading(true);
  axiosInstance
    .get(URL.BUREAU_FILTER)
    .then((res) => {
      setData(res.data);
      setFilteredData(res.data);  
      setLoading(false);
    })
    .catch(() => {
      setError("Failed to fetch Bureau summary data.");
      setLoading(false);
    });
};

const handleSearch = () => {
  const params = {};
  if (fromDate) params.fromDate = fromDate;
  if (toDate) params.toDate = toDate;
  
  if (filterType === "customerId" && customerId) {
    params.customerId = customerId;
  }

  if (!fromDate && !toDate && !customerId  ) {
    fetchPanSummary();  
    return;
  }

  setFiltering(true);
  axiosInstance
    .get(URL.BUREAU_FILTER, { params })
    .then((res) => {
      let responseData = res.data;

       if (responseData && !Array.isArray(responseData)) {
        responseData = [responseData];  
      }

      setFilteredData(responseData);
      setFiltering(false);
    })
    .catch(() => {
      setError("Failed to fetch data with filters.");
      setFiltering(false);
    });
};


  const exportToExcel = () => {
    const ws = XLSX.utils.json_to_sheet(data);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Loan Report");
    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const blob = new Blob([excelBuffer], { type: "application/octet-stream" });
    saveAs(blob, "BUREAU_REPORT_MIS.xlsx");
  };

  const formatDate = (isoDate) => {
    if (!isoDate) return "-";
    const [year, month, day] = isoDate.split("T")[0].split("-");
    return `${day}-${month}-${year}`;
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      handleSearch();
    }
  };

  if (loading) return <Spinner />;
  if (error) return <Alert color="danger">{error}</Alert>;

  return (
    <>
    <div
  style={{
    display: "flex",
    flexWrap: "wrap",
    gap: "15px",
    marginBottom: "20px",
    alignItems: "flex-end",
  }}
  onKeyDown={handleKeyDown}
>
    {/* Filter Type Dropdown */}
    <div style={{ display: "flex", flexDirection: "column" }}>
        <label style={{ fontSize: "12px", fontWeight: "500" }}>Filter Type</label>
        <Input
        type="select"
        className="form-control-alternative form-control"
        value={filterType}
        onChange={(e) => {
            setFilterType(e.target.value);
            // setLoanId("");
            setCustomerId("");
        }}
        style={{ fontSize: "12px", fontWeight: "500" }}
        >
        <option value="">Select Filter</option>
        {/* <option value="loanId">Loan ID</option> */}
        <option value="customerId">Customer ID</option>
        </Input>
    </div>

    {/* Conditionally shown based on filterType */}
    {filterType && (
        <div style={{ display: "flex", flexDirection: "column",fontSize: "12px", fontWeight: "500" }}>
        <label>{filterType === "loanId" ? "Loan ID" : "Customer ID"}</label>
        <Input
            type="text"
            className="form-control-alternative form-control"
            placeholder={`Enter ${filterType === "loanId" ? "Loan ID" : "Customer ID"}`}
            value={filterType === "loanId" ? loanId : customerId}
            onChange={(e) =>
            filterType === "loanId"
                ? setLoanId(e.target.value)
                : setCustomerId(e.target.value)
            }
            style={{ fontSize: "12px", fontWeight: "500" }}
        />
        </div>
    )}

    {/* Loan Status */}
    {/* <div style={{ display: "flex", flexDirection: "column" }}>
        <label style={{ fontSize: "12px", fontWeight: "500" }}>Pan  Status</label>
        <Input
        type="select"
        className="form-control-alternative form-control"
        value={status}
        onChange={(e) => setStatus(e.target.value)}
        style={{ width: "100px", fontSize: "12px", fontWeight: "500" }}
        >
        <option value="">Select</option>
        <option value="1">Success</option>
         <option value="3">Inactive Pan</option>
        <option value="4">Invalid Pan</option>
        

        </Input>
    </div> */}

    {/* From Date */}
    <div style={{ display: "flex", flexDirection: "column" }}>
       <label style={{ fontSize: "12px", fontWeight: "500" }}>From Date</label>
        <Input
        type="date"
        className="form-control-alternative form-control"
        max={new Date().toISOString().split("T")[0]}
        value={fromDate}
        onChange={(e) => setFromDate(e.target.value)}
        style={{ width: "130px",fontSize: "12px", fontWeight: "500" }}
        />
    </div>

    {/* To Date */}
    <div style={{ display: "flex", flexDirection: "column" }}>
        <label style={{ fontSize: "12px", fontWeight: "500" }}>To Date</label>
        <Input
        type="date"
        className="form-control-alternative form-control"
        max={new Date().toISOString().split("T")[0]}
        value={toDate}
        onChange={(e) => setToDate(e.target.value)}
        style={{ width: "130px", fontSize: "12px", fontWeight: "500" }}
        />
    </div>

    {/* Search Button */}
    <div style={{ display: "flex", flexDirection: "column" }}>
        <label>&nbsp;</label>
        <Button
        color="primary"
        onClick={handleSearch}
        disabled={filtering}
        style={{ fontSize: "12px", fontWeight: "500"}}
        >
        {filtering ? "Loading..." : "Search"}
        </Button>
    </div>

    {/* Export Button */}
    <div style={{ display: "flex", flexDirection: "column" }}>
        <label>&nbsp;</label>
        <Button
        color="success"
        onClick={exportToExcel}
        style={{ fontSize: "12px", fontWeight: "500" }}
        >
        Export to Excel
        </Button>
    </div>
    </div>

      <Table bordered striped responsive hover>
       <thead>
  <tr>
    <th>Id</th>  
    <th>Customer ID</th>  
    <th>Score</th>  
    <th>Bureau ID</th>  
    <th>Report Timestamp</th>  
    <th>Member Ref Number</th>  
    <th>Product Code</th>  
    <th>Enquiry ID</th>  
    <th>Name</th>  
    <th>Date of Birth</th>  
    <th>Gender</th> 
    <th>Lead ID</th>  
    <th>Created Date</th>  
    <th>Updated Date</th>  
  </tr>
</thead>

      <tbody>
  {filteredData.length > 0 ? (
    filteredData.map((item, index) => (
      <tr key={item.id || index}>
        <td>{item.id || "N/A"}</td>
        <td>{item.customerId || "N/A"}</td>
        <td>{item.bureauId || "N/A"}</td>
        <td>{item.score || "N/A"}</td>
        <td>{item.reportTimestamp ? formatDate(item.reportTimestamp) : "N/A"}</td>
        <td>{item.memberRefNumber || "N/A"}</td>
        <td>{item.productCode || "N/A"}</td>
        <td>{item.enquiryId || "N/A"}</td>
        <td>{item.customerName || "N/A"}</td>
        <td>{item.dob || "N/A"}</td>
        <td>
          {item.gender === 1
            ? "Male"
            : item.gender === 2
            ? "Female"
            : item.gender === 3
            ? "Transgender"
            : "N/A"}
        </td>
        <td>{item.leadId || "N/A"}</td>
        <td>{item.createDate ? formatDate(item.createDate) : "N/A"}</td>
        <td>{item.updateDate ? formatDate(item.updateDate) : "N/A"}</td>
      </tr>
    ))
  ) : (
    <tr>
      <td colSpan="14" style={{ textAlign: "center" }}>
        No data found.
      </td>
    </tr>
  )}
</tbody>

      </Table>
    </>
  );
};

export default CibilReportMIS;